import {
  ConfirmationAction,
  ConfirmationType,
} from '@modules/confirmation/store/confirmation.action';

export class ConfirmationState {
  public isShowSmsConfirm: boolean;
  public smsCode: string;
}

export function reducer(
  state = new ConfirmationState(),
  action: ConfirmationAction
): ConfirmationState {
  switch (action.type) {
    case ConfirmationType.CloseSmsConfirm: {
      return {
        ...state,
        isShowSmsConfirm: action.payload,
      };
    }
    case ConfirmationType.SetSmsCode: {
      return {
        ...state,
        smsCode: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
